import React, { useState, useCallback } from 'react';
import t from '~t';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { removeBlank, createFromBlank } from '~data/actions/collections';

import { Error } from '~co/overlay/dialog';
import { Item, ItemTitle, Text } from '~ui';
import CollectionIcon from './icon';

export default function CollectionsItemBlank({
  _id,
  level,
  to,
  events: { onItemClick },
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);

  const cancel = useCallback(() => dispatch(removeBlank()), [dispatch]);

  const create = useCallback(() => {
    //cancel
    if (!title.trim()) return cancel();

    //create collection
    setLoading((loading) => {
      if (loading) return loading;

      dispatch(
        createFromBlank(
          { title },
          (newItem) => {
            if (onItemClick) onItemClick(newItem);
            else navigate(to.replace(_id, newItem._id));
          },
          (e) => {
            Error(e);
            cancel();
          },
        ),
      );

      return true;
    });
  }, [title, navigate, _id, to, onItemClick, cancel, dispatch]);

  const onKeyUp = useCallback(
    (e) => {
      switch (e.keyCode) {
        case 27:
          return cancel();
      }
    },
    [cancel],
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      create();
    },
    [create],
  );

  return (
    <form onSubmit={onSubmit}>
      <Item active={true} className='ui-collection-item' style={{ '--level': level }}>
        <div className='ui-collection-expand' />

        <CollectionIcon _id={_id} loading={loading} />

        <ItemTitle>
          <Text
            type='text'
            variant='less'
            required
            autoFocus
            disabled={loading}
            value={title}
            placeholder={t.s('collectionNew')}
            onKeyUp={onKeyUp}
            onChange={(e) => setTitle(e.target.value)}
            onBlur={create}
          />
        </ItemTitle>
      </Item>
    </form>
  );
}
